import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { error, titles } from '../../../web/styles/colors';

export const styles = StyleSheet.create({
	container: {
		padding: 8,
		width: 600,
		boxSizing: 'border-box',
	},
	header: {
		color: titles,
		fontSize: '1.125rem',
		margin: '0 0 24px 0',
	},
	content: {
		overflow: 'auto',
		maxHeight: 750,
	},
	infoFieldContainer: {
		flex: 1,
		minWidth: 0,
	},
	infoFieldLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	infoFieldValue: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	businessInfoGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: THEME.spacing.md,
		marginBottom: THEME.spacing.md,
	},
	fullWidthSection: {
		gridColumn: '1 / 3',
	},
	descriptionValue: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		whiteSpace: 'pre-line',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.xxl,
	},
	notConfiguredText: {
		fontStyle: 'italic',
		fontSize: THEME.typography.fontSizes.sm,
		opacity: 0.6,
		marginBottom: THEME.spacing.lg,
		marginTop: THEME.spacing.sm,
	},
	customContentWebsiteUrl: {
		marginBottom: THEME.spacing.xl,
	},
	buttonContainer: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
	},
	fieldContainer: {
		marginBottom: THEME.spacing.md,
	},
	characterCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
		textAlign: 'right',
	},
	characterCountError: {
		color: error,
		fontWeight: 'bold',
	},
	errorMessage: {
		color: error,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
});
